module.exports = __webpack_public_path__ + "static/img/northYork2.f627057.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/northYork2.jpg
// module id = 112
// module chunks = 9